import { Pencil, MapPin, Users, Clock, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { MOBILE_STATUSES, formatAdminDate } from "@/components/admin/adminShared";

const BLOCK_LABELS = { full_day: "Tot el dia", morning: "Matí", evening: "Nit", custom: "Franja concreta", none: "No bloqueja" };

function Row({ icon: Icon, children }) {
  if (!children) return null;
  return <p className="flex items-center gap-2 text-sm text-[#2A2421]"><Icon size={14} className="text-[#3e664c]" /> {children}</p>;
}

export default function CalendarEventDetail({ item, onClose, onEdit }) {
  const isMobile = item?.source === "mobile";
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-md" data-testid="master-calendar-detail">
        {item && (
          <>
            <DialogHeader>
              <p className={`uppercase tracking-[0.28em] text-[10px] ${isMobile ? "text-[#C9A24B]" : "text-[#3e664c]"}`} data-testid="master-detail-source">
                {isMobile ? "AURA Esdeveniments Externs" : `Sala · ${item.type === "public" ? "Públic" : "Privat"}`}
              </p>
              <DialogTitle className="font-display text-3xl tracking-tight" data-testid="master-detail-title">{item.title}</DialogTitle>
              <DialogDescription className="text-[#5C544F]">{formatAdminDate(item.date)}</DialogDescription>
            </DialogHeader>
            <div className="space-y-2">
              <Row icon={Clock}>{item.time ? `${item.time}${item.end_time ? ` – ${item.end_time}` : ""}` : null}</Row>
              {isMobile ? (
                <>
                  <span className={`inline-block px-2.5 py-1 rounded-full text-[11px] ${MOBILE_STATUSES[item.status]?.chip}`}>{MOBILE_STATUSES[item.status]?.label}</span>
                  <Row icon={Users}>{item.client_name}{item.attendees ? ` · ${item.attendees} persones` : ""}</Row>
                  <Row icon={Phone}>{item.client_phone}</Row>
                  <Row icon={MapPin}>{item.location}</Row>
                  {item.services?.length > 0 && <p className="text-xs text-[#5C544F]">Serveis: {item.services.join(", ")}</p>}
                </>
              ) : (
                <>
                  <p className="text-xs text-[#5C544F]">Bloqueig: {BLOCK_LABELS[item.blocks_availability] || item.blocks_availability}</p>
                  {item.description && <p className="text-sm text-[#5C544F] line-clamp-4">{item.description}</p>}
                </>
              )}
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={onClose} data-testid="master-detail-close">Tancar</Button>
              <Button onClick={() => onEdit(item)} data-testid="master-detail-edit" className="rounded-full bg-[#3e664c] hover:bg-[#2e5949] text-white gap-2 px-6">
                <Pencil size={14} /> Editar
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
